import type {CopilotWorkStartedEventInfo, TimelineItem} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {safeHttpUrl} from '../../../helpers/unified-batch-url-safety'

export function getCopilotWorkAutomation(info: Pick<CopilotWorkStartedEventInfo, 'automationName' | 'automationUrl'>) {
  const name = info.automationName?.trim()
  const url = safeHttpUrl(info.automationUrl?.trim())
  return name && url ? {name, url} : undefined
}

export function getTimelineItemAutomation(item: TimelineItem) {
  const info = item.additionalInfo?.info
  return info?.case === 'copilotWorkStartedEvent' ||
    info?.case === 'copilotWorkFinishedEvent' ||
    info?.case === 'copilotWorkFinishedFailureEvent'
    ? getCopilotWorkAutomation(info.value)
    : undefined
}
